<template>
    <nuxt-loading-indicator color="#FEA138" :height="3"></nuxt-loading-indicator>
    <header-component v-if="mainStore.location"></header-component>

    <slot></slot>

    <footer-component v-if="mainStore.location"></footer-component>
    <div id="overlay-container"></div>
</template>

<script setup lang="ts">

import HeaderComponent from '~/components/header/index.vue'
import FooterComponent from '~/components/footer/index.vue'
import { useMainStore } from '~/store/mainState';

const mainStore = useMainStore();

if (!mainStore.location) {
    mainStore.tryInit();
}

</script>